import { VITE_POSTHOG_KEY, VITE_POSTHOG_HOST } from '../../constants/envs';
import { PostHogProvider } from './providers/posthog.provider';
import { NoopProvider } from './providers/noop.provider';
import type { tAnalyticsProvider } from './analytics.types';
import { LLog, LOG_COMPONENTS, LOG_OPERATIONS } from '../logging';

if (!VITE_POSTHOG_KEY && !import.meta.env.PROD) {
  LLog.error(
    { component: LOG_COMPONENTS.API, method: 'analytics', operation: LOG_OPERATIONS.ERROR },
    'VITE_POSTHOG_KEY is not set — analytics disabled',
  );
}

const _provider: tAnalyticsProvider = VITE_POSTHOG_KEY
  ? new PostHogProvider(VITE_POSTHOG_KEY, VITE_POSTHOG_HOST)
  : new NoopProvider();

export function getAnalytics(): tAnalyticsProvider {
  return _provider;
}
